import { Code } from '@tiptap/extension-code';

export const CustomCode = Code.extend({
   addKeyboardShortcuts() {
      return {
         'Mod-e': () => this.editor.commands.toggleCode(),
         'Mod-`': () => this.editor.commands.toggleCode(),
      };
   },
   // @ts-ignore This has been working in production; TipTap appears to have it typed incorrectly
   excludes: null,
   priority: 200,
});
